import { createSelector } from 'reselect';

import { getSelectedDealer } from 'selectors/dealerSelectors';
import { uniq } from 'utils/ObjectUtils';
import { getProps } from 'utils/selectors';

export const getSelectedAuditModels = createSelector(
  getSelectedDealer,
  /**
   * @param {import('modules/dealers/types').Dealer} dealer
   * @returns {Array<string>}
   */
  dealer => uniq(
    Object.values(dealer?.config?.audit?.selectedAuditModels ?? {}).reduce(
      (acc, { ids = [] }) => [...acc, ...ids],
      []
    )
  )
);

export const getDefaultAuditModels = createSelector(
  getSelectedDealer,
  /**
   * @param {import('modules/dealers/types').Dealer} dealer
   * @returns {Array<string>}
   */
  dealer =>
    uniq(
      Object.values(dealer?.assignments?.defaultAuditModels ?? {}).reduce((acc, byBrandId) => {
        Object.values(byBrandId).forEach(auditModels => {
          auditModels.forEach(({ id }) => acc.push(id));
        });
        return acc;
      }, [])
    )
);

export const getIsAuditModelConfigured = createSelector(
  getSelectedAuditModels,
  getDefaultAuditModels,
  getProps,
  (selectedAuditModelIds, defaultAuditModels, auditModelId) => selectedAuditModelIds.includes(auditModelId) || defaultAuditModels.includes(auditModelId)
);
